// Fires whenever an agent copies selected text in a message bubble.
// Requires data-message-id / data-conversation-id on the bubble element.

(function () {
  let lastSentAt = 0;

  function onCopy() {
    const sel = window.getSelection();
    if (!sel || sel.isCollapsed) return;

    // Find the nearest message bubble container
    const node = sel.anchorNode && (sel.anchorNode.nodeType === 3 ? sel.anchorNode.parentElement : sel.anchorNode);
    if (!node) return;
    const bubble = node.closest('.message-bubble-container');
    // throttle so we don't spam
    const now = Date.now();
    if (now - lastSentAt < 1500) return;
    lastSentAt = now;

    const payload = JSON.stringify({
      event: 'message.copied',
      snippet: sel.toString().slice(0, 500),
      at: new Date().toISOString(),
      message_id: bubble.dataset.messageId,
      conversation_id: bubble.dataset.conversationId,
      inbox_id: bubble.dataset.inboxId,
      actor_id: window.__CW_CURRENT_USER_ID || null,
      actor_email: window.__CW_CURRENT_USER_EMAIL || null,
      actor_role: window.__CW_CURRENT_USER_ROLE || null
    });

    const url = 'https://www.globalassignmentservices.com/dashboard/handleCopyEvent.php';
    navigator.sendBeacon?.(url, new Blob([payload], { type: 'text/plain;charset=UTF-8' })) || fetch(url, {method: 'POST',mode: 'cors',credentials: 'omit',headers: { 'Content-Type': 'text/plain;charset=UTF-8' },body: payload,keepalive: true,});
  }

  document.addEventListener('copy', onCopy, true);
})();
